$(function () {
  const breakingPoint = {
    phone: 480,
    tablet: 768,
    tabletLandscape: 992,
    desktop: 1200,
  };
  if ( window.innerWidth < breakingPoint.tablet ) {
    return ;
  }
  // =============================== api ===============================
  var projectId = $('#project').data('sf-id');

  var domain = 'py3-api.citiesocial.com';
  var collection_api =
    '//' + domain + '/early-bird/visualized-projects/' + projectId + '/';

  $.get(collection_api, function (project) {
    const PROJECT_IS_SHOW_RADAR = project.is_show_radar;
    const PROJECT_IS_SHOW_SCORE = project.is_show_score;
    const PROJECT_IS_SHOW_KOL_REVIEW = project.is_show_kol_review;
    const PROJECT_IS_PRESS_REVIEW = project.is_show_press_review;

    const PROJECT_NOT_BEGIN = 'PROJECT_NOT_BEGIN';
    const PROJECT_AVAILABLE = 'PROJECT_AVAILABLE';
    const PROJECT_FINISHED = 'PROJECT_FINISHED';
    var projectStatus = getProjectStatus(project);

    function getProjectStatus(project) {
      var projectStartAt = Date.parse(project.available_at);
      var projectEndAt = Date.parse(project.deadline);

      if (Date.now() < projectStartAt) {
        return PROJECT_NOT_BEGIN;
      } else if (projectStartAt < Date.now() && Date.now() < projectEndAt) {
        return PROJECT_AVAILABLE;
      } else {
        return PROJECT_FINISHED;
      }
    }

    // Extra Tabs
    showExtraTabs(project.extra_tabs);
    // 刪除不必要的元素
    removeUnnecessaryElement();

    // 分類
    const categoryTitle = project.category?.menu_collection?.title;
    if (categoryTitle) {
      $('#category').html(categoryTitle);

      Citiesocial.productManager.displayEarlyBirdSameCategoryCollectionCarousel({
        earlyBirdProjectId: project.shopify_product_id,
        categoryTitle
      });
    } else {
      $('#eb-category-vertical-slash').remove();
    }

    // 圖片
    $('.product-img').attr('src', project.image);

    // 倒數
    var countdown = setInterval(function () {
      // Get today's date and time
      var now = new Date().getTime();

      var deadline = new Date(project.deadline).getTime();

      // Find the distance between now and the count down date
      var distance = deadline - now;

      // Time calculations for days, hours, minutes and seconds
      var days = Math.floor(distance / (1000 * 60 * 60 * 24));
      var hours = Math.floor(
        (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60),
      );
      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((distance % (1000 * 60)) / 1000);

      var text =
        '倒數 ' +
        days +
        ' 日 ' +
        hours +
        ' 時 ' +
        minutes +
        ' 分 ' +
        seconds +
        ' 秒';

      $('.countdown').html(text);

      if (distance < 0) {
        clearInterval(countdown);
        $('.countdown').html('已結束');
      }
    }, 1000);
    // 進度
    var initGoal = project.goals.find(function (item) {
      return item.value === 0;
    });
    var mainGoal = project.goals.find(function (item) {
      return item.value > 0;
    });
    if (initGoal === undefined) {
      initGoal = { value: 0, is_reached: false };
    }
    if (mainGoal === undefined) {
      mainGoal = { value: 0, is_reached: false };
    }

    var currentTotal = 20000000;
    if (project.total_amount !== null) {
      currentTotal = project.total_amount;
    }
    $('.amount').html('NT$ ' + formatNumber(currentTotal));

    var percentage = Math.round((currentTotal / mainGoal.value) * 100);
    $('#currentPercent').html(percentage);

    if (percentage >= 100) {
      percentage = 100;
    }

    // 按鈕文案更新 (下面 plans 也有用到)
    if (projectStatus === PROJECT_FINISHED) {
      $('.buy-btn').parent().remove();
      $('.popup-msg').remove();
      $('.arrow-down').remove();
    } else {
      var btnText;
      if (mainGoal.is_reached) {
        btnText = mainGoal.reached_btn_text;
      } else {
        btnText = initGoal.reached_btn_text;
      }
      $('.buy-btn').html(btnText);
    }

    // 限量
    $('#limit').html(project.max_initial_inventory_quantity);
    $('#amount-purchase').html(project.order_count);
    // 預購時間
    var begin = timeFormat(project.available_at);
    var end = timeFormat(project.deadline);
    var timeText = begin + '~' + end;
    $('#plan-time').html(timeText);

    // =============================== 計畫介紹 cs-early-bird-info-main.liquid ===============================
    // 產品特色
    let fs = [];
    try {
      fs = project.features;
    } catch (error) {
      fs = [{ item: '產品特色格式錯誤' }];
    }
    var ul = document.getElementById('features');
    $.each(fs, function (i, feature) {
      var li = document.createElement('li');
      li.appendChild(document.createTextNode(feature.item));
      ul.appendChild(li);
    });

    if (PROJECT_IS_SHOW_RADAR) {
      // 雷達圖標題
      $('#radar-sub').html(project.radar_title);

      // 雷達圖資料
      var canvas = document.getElementById('radar-chart');
      canvas.width = '80%';
      canvas.height = 280;
      window.myRadar = new Chart(
        canvas,
        radarObject(project.radar.labels, project.radar.data),
      );
    } else {
      $('div.radar-section').hide();
    }

    if (PROJECT_IS_PRESS_REVIEW) {
      // 評測觀點
      // 媒體
      var $press = $('#press-section');
      $.each(project.press_reviews, function (i, press) {
        var pressRoot = $('<div></div>').addClass('press-review');
        var pressImg = $('<img></img>')
          .addClass('ui circular image press-img')
          .attr('src', press.reviewer.avatar_url);
        pressRoot.append(pressImg);

        var nameText = press.reviewer.title + ' | ' + press.reviewer.name;
        var info = $('<span></span>')
          .addClass('press-info')
          .html(press.reviewer.intro);
        var pressName = $('<div></div>')
          .addClass('reviewer-name')
          .attr('style', 'margin-left: 16px;')
          .append(nameText, '<br>', info);
        pressRoot.append(pressName);

        var arrow = $('<div></div>').addClass('arrow-up');
        pressRoot.append(arrow);

        var msg = $('<div></div>').addClass('press-msg').html(press.summary);
        pressRoot.append(msg);
        $press.append(pressRoot);
      });
    } else {
      $('div.main-title:contains("評測觀點")').hide();
      $('#press-section').hide();
    }

    if (PROJECT_IS_SHOW_KOL_REVIEW) {
      // KOL
      var firstKol = project.kol_reviews[0];
      if (firstKol != undefined) {
        var $mainKol = $('#main-section');
        $mainKol
          .find('.reviewer-img')
          .attr('src', firstKol.reviewer.avatar_url);
        var kolName = firstKol.reviewer.title + ' | ' + firstKol.reviewer.name;
        $mainKol.find('.reviewer-name').html(kolName);
        $mainKol.find('.quote').append(firstKol.summary);

        var $kolLink = $('<a></a>')
          .attr('href', firstKol.article_url)
          .addClass('kol-link')
          .attr('target', '_blank')
          .html('看專家評測');

        var $kolArticle = $('<div></div>')
          .addClass('reviewer-article')
          .html(firstKol.content + '...');

        var textWarp = $('<div></div>')
          .addClass('kol-text')
          .append($kolArticle);

        $mainKol.append(textWarp);

        appendKolLink($kolArticle, $kolLink, firstKol.content);
      }
    } else {
      $('#main-section').hide();
    }

    // 關於品牌
    $('.brand-title').html(project.brand_name);
    $('.brand-info').html(project.brand_summary);

    $('.main-content').html(project.content);
    $('.main-content').fitVids();

    // =============================== 心得評測 cs-early-bird-info-main.liquid ===============================

    if (PROJECT_IS_SHOW_SCORE) {
      // 綜合評測分數
      var totalScore = 0;
      $.each(project.scores, function (i, score) {
        var title = $('<div></div>').addClass('item-title').html(score.title);
        var sub = $('<div></div>').addClass('item-info').html(score.subtitle);
        var section = $('<div></div>').addClass('line-section');

        for (let index = 1; index <= 5; index++) {
          var line = $('<div></div>').addClass('score-line');
          if (index === Math.floor(score.value)) {
            // 順便加分數
            totalScore += index;
            line.addClass('active');
          }
          section.append(line);
        }

        $('.score-item').append(title, sub, section);
      });
      var final = totalScore / project.scores.length;
      $('.score-number').html(round(final, 1).toFixed(1));
    } else {
      $('div.total-score').hide();
      $('div.score-item').hide();
    }

    if (PROJECT_IS_PRESS_REVIEW) {
      // 媒體評測
      var $pressReviews = $('#press-reviews');
      $.each(project.press_reviews, function (i, press) {
        var pressRoot = $('<div></div>').addClass('review-container');
        var pressImg = $('<img></img>')
          .addClass('ui image article-img')
          .attr('src', press.article_image_url);
        pressRoot.append(pressImg);

        var title = $('<span></span>')
          .addClass('article-title')
          .html(press.article_title);
        var pressName = $('<div></div>')
          .addClass('press-name')
          .append(press.press_name, '<br>', title);
        pressRoot.append(pressName);

        var pressLink = $('<a></a>')
          .attr('href', press.article_url)
          .addClass('article-link')
          .attr('target', '_blank')
          .html('繼續閱讀');
        var $content = $('<div></div>')
          .addClass('article-content')
          .html(press.article_summary);
        var textWarp = $('<div></div>')
          .addClass('article-text')
          .append($content);
        pressRoot.append(textWarp);

        $pressReviews.append(pressRoot);

        var width = window.innerWidth > 0 ? window.innerWidth : screen.width;
        let wordMax;

        if (width > 480) {
          var desktop = width * 0.34;
          wordMax = Math.ceil((desktop / 16) * 2);
          if (press.article_summary.length > wordMax) {
            $content.html(linkString(wordMax, press.article_summary));
          }
        } else {
          wordMax = Math.ceil((width / 19.5) * 2);
          if (press.article_summary.length > wordMax) {
            $content.html(linkString(wordMax, press.article_summary));
          }
        }

        $content.append('...', pressLink);
      });
    } else {
      $('.press-review').hide();
    }

    if (PROJECT_IS_SHOW_KOL_REVIEW) {
      // 專業評測
      var $kolReviews = $('#kol-reviews');
      $.each(project.kol_reviews, function (i, kol) {
        var kolRoot = $('<div></div>')
          .addClass('main-review')
          .attr('style', 'margin-top: 0');

        var kolImg = $('<img></img>')
          .addClass('ui circular centered image reviewer-img')
          .attr('src', kol.reviewer.avatar_url);
        kolRoot.append(kolImg);

        var name = kol.reviewer.title + ' | ' + kol.reviewer.name;
        var kolName = $('<div></div>').addClass('reviewer-name').html(name);
        kolRoot.append(kolName);

        var sign = $('<span></span>').addClass('quote-sign').html('“');
        var quote = $('<div></div>')
          .addClass('quote')
          .append(sign, kol.summary);
        kolRoot.append(quote);

        var $kolLink = $('<a></a>')
          .attr('href', kol.article_url)
          .addClass('kol-link')
          .attr('target', '_blank')
          .html('看專家評測');

        var $kolArticle = $('<div></div>')
          .addClass('reviewer-article')
          .html(kol.content + '...');

        var textWarp = $('<div></div>')
          .addClass('kol-text')
          .append($kolArticle, $kolLink);

        $kolReviews.append(kolRoot);
        $kolReviews.append(textWarp);

        appendKolLink($kolArticle, $kolLink, kol.content);
      });
    } else {
      $('div.review-header:contains("專業評測")').hide();
      $('#kol-reviews').hide();
    }

    // =============================== 方案 cs-early-bird-plans.liquid ===============================
    var groupPlans = project.group_plans;

    var $blockSection = $('#block-section');

    const IS_SHOW_PLAN_PRICE = project.is_show_plans;

    groupPlans = getPlanGroupInStockOrNot(groupPlans);

    var sortedGroups = sortPlanGroupByPositionAndIsSoldOut(groupPlans);

    sortedGroups.forEach(function renderByBlock(group) {
      if (group.isGroup) {
        var selectedPlan = getDefaultSelectedPlan(group.data);

        // render the initial plan group layout
        var $planBlock = $(
          renderByPlanGroup(
            projectStatus,
            group.is_sold_out,
            selectedPlan,
            sortPlansByIsSoldOut(group.data),
          ),
        );
        $blockSection.append($planBlock);

        // handle buy button click
        var handleClickFunction = generateClickFunction(
          selectedPlan.shopify_variant_id,
        );
        $planBlock.find('.add-plan-btn').on('click', handleClickFunction);

        // eslint-disable-next-line no-inner-declarations
        function generateClickFunction(variantId) {
          return function handleClick() {
            Citiesocial.cartManager.quickAddToCart(null, variantId);
          };
        }

        // update the plan block information with the selected plan
        $planBlock.find('.single-option-selector').on('change', handleSelect);

        // eslint-disable-next-line no-inner-declarations
        function handleSelect(e) {
          // update selectedPlan
          selectedPlan = group.data.find(function findPlanWithId(plan) {
            return plan.shopify_variant_id == e.target.value;
          });

          // update UI
          $planBlock
            .find('.plan-img')
            .attr('src', selectedPlan.image_url)
            .attr('alt', selectedPlan.plan_title);
          $planBlock.find('.plan-title').html(selectedPlan.plan_title);
          $planBlock.find('.plan-price').html(`NT$ ${selectedPlan.price}`);
          $planBlock
            .find('.plan-market-price')
            .html(`NT$ ${selectedPlan.compare_at_price}`);
          $planBlock
            .find('.limit-count')
            .html(selectedPlan.initial_inventory_quantity);
          $planBlock
            .find('.plan-ordered')
            .html(
              `已售出 ${formatProductSoldCount(
                selectedPlan.product_sold_count,
                selectedPlan.initial_inventory_quantity,
              )} 組`,
            );
          $planBlock.find('.plan-content').html(selectedPlan.content);
          $planBlock.find('.reward-point').html(selectedPlan.reward_point);
          if (selectedPlan.reward_point <= 0) {
            $planBlock.find('.unlock-title').hide();
            $planBlock.find('.unlock-info').hide();
          }
          $planBlock
            .find('.shipout')
            .html(
              `預計出貨時間：${formatShipAt(
                selectedPlan.ship_at,
                selectedPlan.is_estimated_date_using_general_rule,
              )}`,
            );
          $planBlock
            .find('.add-plan-btn')
            .attr('data-variant-id', selectedPlan.shopify_variant_id);

          // update event listener
          $planBlock.find('.add-plan-btn').off('click', handleClickFunction);
          handleClickFunction = generateClickFunction(
            selectedPlan.shopify_variant_id,
          );
          $planBlock.find('.add-plan-btn').on('click', handleClickFunction);
        }
      } else {
        $blockSection.append(renderByPlan(projectStatus, group.data));
      }
    });

    function renderByPlanGroup(projectStatus, allSoldOut, selectedPlan, plans) {
      var title,
        buttonDisableClassName,
        btnText,
        planOptions,
        blockDisableClassName,
        initialInventoryQuantity,
        productSold;

      var shipAt = formatShipAt(
        selectedPlan.ship_at,
        selectedPlan.is_estimated_date_using_general_rule,
      );

      if (projectStatus === PROJECT_NOT_BEGIN) {
        title = selectedPlan.group_name;
        initialInventoryQuantity = sumOfPlansInitialInventoryQuantity(plans);
        productSold = 0;
        buttonDisableClassName = 'disabled';
        btnText = '尚未開賣';
        blockDisableClassName = 'disabled';
        planOptions = '<option value="project_not_begin">尚未開賣</option>';
      } else if (projectStatus === PROJECT_AVAILABLE) {
        if (allSoldOut) {
          title = selectedPlan.group_name;
          initialInventoryQuantity = sumOfPlansInitialInventoryQuantity(plans);
          productSold = initialInventoryQuantity;
          buttonDisableClassName = 'disabled';
          btnText = '已售完';
          blockDisableClassName = 'disabled';
          planOptions = '<option value="sold_out">已售完</option>';
        } else {
          title = selectedPlan.plan_title;
          initialInventoryQuantity = selectedPlan.initial_inventory_quantity;
          productSold = selectedPlan.product_sold_count;
          buttonDisableClassName = '';
          btnText = '加入購物車 | <span class="buy-btn">30 天買貴退差價</span>';
          blockDisableClassName = '';
          planOptions = getPlanOptions(plans);
        }
      } else if (projectStatus === PROJECT_FINISHED) {
        title = selectedPlan.group_name;
        initialInventoryQuantity = sumOfPlansInitialInventoryQuantity(plans);
        productSold = initialInventoryQuantity;
        buttonDisableClassName = 'disabled';
        btnText = '預購結束';
        blockDisableClassName = 'disabled';
        planOptions = '<option value="project_finished">預購結束</option>';
      } else {
        // handle project status type error
      }

      var productSoldCount = formatProductSoldCount(
        productSold,
        initialInventoryQuantity,
      );

      var planGroupBlockTemplate = `
        <div class="plan-block ${blockDisableClassName}">
          <img class="plan-img" src=${selectedPlan.image_url} alt=${
        selectedPlan.plan_title
      } />
          <div class="plan-info">
            <div class="plan-title">${title}</div>
            ${
              IS_SHOW_PLAN_PRICE
                ? `<div class="plan-price">
                    NT$ ${selectedPlan.price}
                  </div>
                  <del class="plan-market-price">NT$ ${selectedPlan.compare_at_price}</del>
                  <span class="plan-market">未來市價</span>
                  <br>`
                : ``
            }
            <div class="plan-limit">
              限量 <span class="limit-count">${initialInventoryQuantity}</span> 組
            </div>
            <div class="plan-ordered">已售出 ${productSoldCount} 組</div>
            <div class="plan-content">${selectedPlan.content}</div>
            ${
              selectedPlan.reward_point
                ? `<div class="unlock-title">解鎖優惠</div>
                  <div class="unlock-info">
                    限量 <span class="limit-count">${initialInventoryQuantity}</span> 組購買後可額外獲得
                    <span class="reward-point">${selectedPlan.reward_point}</span> 元現金折價券
                  </div>`
                : ''
            }
            <div class="shipout">預計出貨時間：${shipAt}</div>
    
            <div class="styled-select util-mb-12">
              <select 
                class="single-option-selector"  
                data-selector-type="select"
                value="${selectedPlan.shopify_variant_id}"
              >
                ${planOptions}
              </select>
    
              <svg id="icon-dropdown-arrow" viewBox="0 0 32 32">
                <title>dropdown-arrow</title>
                <path class="path1" d="M-0 9.337c0-0.688 0.261-1.375 0.781-1.901 1.045-1.050 2.735-1.050 3.777 0l11.435 11.419 11.435-11.419c1.045-1.050 2.735-1.050 3.777 0 1.045 1.050 1.045 2.753 0 3.804l-13.322 13.32c-1.045 1.053-2.735 1.053-3.777 0l-13.325-13.32c-0.52-0.528-0.781-1.213-0.781-1.903z"></path>
              </svg>
            </div>
    
            <div 
              class="cs-productItem-imageWrapper-quckshopOverlay cs-productItem-quickAddWrapper-button add-plan-btn eb-basic-btn ${buttonDisableClassName}" 
              data-action="quick-add-to-cart" 
              data-variant-id="${selectedPlan.shopify_variant_id}"
            >
              ${btnText}
            </div>
    
          </div>
        </div>
      `;

      return planGroupBlockTemplate;
    }

    function renderByPlan(projectStatus, plan) {
      var buttonDisableClassName,
        btnText,
        blockDisableClassName,
        initialInventoryQuantity,
        productSold,
        shipAt;

      shipAt = formatShipAt(
        plan.ship_at,
        plan.is_estimated_date_using_general_rule,
      );

      if (projectStatus === PROJECT_NOT_BEGIN) {
        initialInventoryQuantity = plan.initial_inventory_quantity;
        productSold = 0;
        buttonDisableClassName = 'disabled';
        btnText = '尚未開賣';
        blockDisableClassName = 'disabled';
      } else if (projectStatus === PROJECT_AVAILABLE) {
        if (plan.is_sold_out) {
          initialInventoryQuantity = plan.initial_inventory_quantity;
          productSold = initialInventoryQuantity;
          buttonDisableClassName = 'disabled';
          btnText = '已售完';
          blockDisableClassName = 'disabled';
        } else {
          initialInventoryQuantity = plan.initial_inventory_quantity;
          productSold = plan.product_sold_count;
          buttonDisableClassName = '';
          btnText = '加入購物車 | <span class="buy-btn">30 天買貴退差價</span>';
          blockDisableClassName = '';
        }
      } else if (projectStatus === PROJECT_FINISHED) {
        initialInventoryQuantity = plan.initial_inventory_quantity;
        productSold = initialInventoryQuantity;
        buttonDisableClassName = 'disabled';
        btnText = '預購結束';
        blockDisableClassName = 'disabled';
      } else {
        // handle project status type error
      }

      var productSoldCount = formatProductSoldCount(
        productSold,
        initialInventoryQuantity,
      );

      var planBlock = `
        <div class="plan-block ${blockDisableClassName}">
          <img class="plan-img" src=${plan.image_url} alt=${plan.plan_title} />
          <div class="plan-info">
            <div class="plan-title">${plan.plan_title}</div>
            ${
              IS_SHOW_PLAN_PRICE
                ? `<div class="plan-price">
                    NT$ ${plan.price}
                  </div>
                  <del class="plan-market-price">NT$ ${plan.compare_at_price}</del>
                  <span class="plan-market">未來市價</span>
                  <br>`
                : ``
            }
            <div class="plan-limit">
              限量 <span class="limit-count">${initialInventoryQuantity}</span> 組
            </div>
            <div class="plan-ordered">已售出 ${productSoldCount} 組</div>
            <div class="plan-content">${plan.content}</div>
            ${
              plan.reward_point
                ? `<div class="unlock-title">解鎖優惠</div>
                  <div class="unlock-info">
                    限量 <span class="limit-count">${initialInventoryQuantity}</span> 組購買後可額外獲得
                    <span class="reward-point">${plan.reward_point}</span> 元現金折價券
                  </div>`
                : ''
            }
    
            <div class="shipout">預計出貨時間：${shipAt}</div>
    
            <div 
              class="cs-productItem-imageWrapper-quckshopOverlay cs-productItem-quickAddWrapper-button add-plan-btn eb-basic-btn ${buttonDisableClassName}" 
              data-action="quick-add-to-cart" 
              data-variant-id="${plan.shopify_variant_id}"
              onclick="Citiesocial.cartManager.quickAddToCart(this, ${
                plan.shopify_variant_id
              })"
            >
              ${btnText}
            </div>
    
          </div>
        </div>
      `;

      return planBlock;
    }

    function showExtraTabs(extra_tabs) {
      extra_tabs.forEach((tab, index) => {
        if (!tab.is_show) {
          return;
        }
        $('.tab-mod').append(
          `<a class="item tab-item" data-tab="extra_tabs_${index}">${tab.title}</a>`,
        );
        $('.eb-container > .row > .col-md-7').append(
          `<div class="ui tab" data-tab="extra_tabs_${index}">${tab.content}</div>`,
        );
      });
      $('.item').click(function () {
        $(this).siblings('.active').removeClass('active');
        $(this).addClass('active');

        var target = $(this).data('tab');
        var target_tab = '.tab[data-tab="' + target + '"]';

        $(target_tab).siblings('.active').removeClass('active');
        $(target_tab).addClass('active');
      });
      $('.tab-item[data-tab]').click(function () {
        const element = document.querySelector('.eb-basic-btn');
        var top = element.getBoundingClientRect().top + window.pageYOffset - 50;
        var width = window.innerWidth > 0 ? window.innerWidth : screen.width;
        if (width > 480) {
          top -= 25;
        }
        window.scrollTo({
          top,
        });
      });
    }

    function removeUnnecessaryElement() {
      if (
        PROJECT_IS_SHOW_SCORE === false &&
        PROJECT_IS_SHOW_KOL_REVIEW === false &&
        PROJECT_IS_PRESS_REVIEW === false
      ) {
        $('.more-review').hide();
        $('.tab-item:contains("心得評測")').hide();
      }
    }

    function getDefaultSelectedPlan(plans) {
      var plan = plans.find(function notSoldOut(plan) {
        return !plan.is_sold_out;
      });

      return plan || plans[0];
    }

    function getPlanGroupInStockOrNot(groups) {
      groups.forEach(function checkPlanGroupInStockOrNot(group) {
        if (group.isGroup) {
          group.is_sold_out = isPlansAllSoldOut(group.data);
        } else {
          group.is_sold_out = group.data.is_sold_out;
        }
      });

      return groups;
    }

    function sortPlanGroupByPositionAndIsSoldOut(groups) {
      groups = groups.sort(function sortByPosition(group1, group2) {
        if (group1.position < group2.position) return -1;
        else if (group1.position > group2.position) return 1;
        else return 0;
      });

      var inStockGroups = groups.filter(function inStockGroup(group) {
        return !group.is_sold_out;
      });

      var soldOutGroups = groups.filter(function soldOutGroup(group) {
        return group.is_sold_out;
      });

      return [...inStockGroups, ...soldOutGroups];
    }

    function isPlansAllSoldOut(plans) {
      var result = true;
      plans.forEach(function checkIsSoldOut(plan) {
        if (!plan.is_sold_out) {
          result = false;
        }
      });
      return result;
    }

    function formatShipAt(shipAt, isUsingGeneralRule) {
      if (isUsingGeneralRule) {
        return '下單後第 2 個工作日';
      } else if (shipAt == null) {
        return '未定';
      } else {
        return shipAt.replace(/-/g, '/');
      }
    }

    function formatProductSoldCount(count, max) {
      return count > max ? max : count;
    }

    function sortPlansByIsSoldOut(plans) {
      return [
        ...plans.filter(function notSoldOut(plan) {
          return !plan.is_sold_out;
        }),
        ...plans.filter(function soldOut(plan) {
          return plan.is_sold_out;
        }),
      ];
    }

    function getPlanOptions(plans) {
      var planOptions = '';
      plans.forEach(function getPlanOption(plan) {
        var option = `
        <option 
          value=${plan.shopify_variant_id} 
          ${plan.is_sold_out ? 'disabled' : ''}
        >
          ${plan.option_name} ${plan.is_sold_out ? '(已售完)' : ''}
        </option>`;
        planOptions = planOptions + option;
      });

      return planOptions;
    }

    function sumOfPlansInitialInventoryQuantity(plans) {
      return plans.reduce(function planInitialInventoryQuantityReducer(
        sum,
        plan,
      ) {
        return sum + plan.initial_inventory_quantity;
      },
      0);
    }

    // =============================== 常見問答 cs-early-bird-info-faq.liquid ===============================

    $.each(project.qa, function (i, item) {
      var qaRoot = $('<div></div>')
        .addClass('faq-box')
        .attr('data-open', 'false')
        .attr('data-toggle', 'collapse')
        .attr('data-target', '#ans-' + i)
        .attr('aria-expanded', 'false');

      var qIcon = $('<i></i>').addClass('cs_icon icon-arrowDown faq-icon');
      var qSelf = $('<span></span>')
        .addClass('faq-q')
        .html(i + 1 + '. ' + item.question);

      var question = $('<div></div>').addClass('question').append(qIcon, qSelf);

      qaRoot.append(question);

      var ans = $('<div></div>')
        .addClass('collapse ans')
        .attr('id', 'ans-' + i)
        .html('A. ' + item.answer);

      qaRoot.append(ans);

      $('#qa-section').append(qaRoot);
    });
    $('#loading-overlay').hide();
  });

  // =============================== listeners ===============================

  $('.item').click(function () {
    $(this).siblings('.active').removeClass('active');
    $(this).addClass('active');

    var target = $(this).data('tab');
    var target_tab = '.tab[data-tab="' + target + '"]';

    $(target_tab).siblings('.active').removeClass('active');
    $(target_tab).addClass('active');
  });

  $('.more-review').click(function () {
    $("[data-tab='review']").click();
  });

  $('.tab-item[data-tab]').click(function () {
    const element = document.querySelector('.eb-basic-btn');
    var top = element.getBoundingClientRect().top + window.pageYOffset - 50;
    var width = window.innerWidth > 0 ? window.innerWidth : screen.width;
    if (width > 480) {
      top -= 25;
    }

    window.scrollTo({
      top,
    });
  });

  $('#ins-trigger').click(function () {
    var popup = document.getElementById('instruction');
    popup.classList.toggle('show');
  });

  $('.share').click(function () {
    if (navigator.share) {
      var text = $(this).data('title');
      navigator
        .share({
          title: '分享早鳥首映計畫',
          text: text,
          url: document.location.href,
        })
        .then(() => console.log('Successful share'))
        .catch((error) => console.log('Error sharing', error));
    } else {
      $(this).siblings('.main-share').toggle();
    }
  });

  var width = window.innerWidth > 0 ? window.innerWidth : screen.width;
  var menuOffset = 122;
  if (width <= 480) {
    menuOffset = 91;
  }
  window.onscroll = function () {
    fixMenu();
  };

  var menu = document.getElementById('fix-menu');
  var sticky = menu.offsetTop - menuOffset;

  function fixMenu() {
    var $fixmenu = $('.fix-btns');
    var $mobilemenu = $('.mobile-btns');
    var width = window.innerWidth > 0 ? window.innerWidth : screen.width;
    var h = $('#shopify-section-header').height()  + $('#shopify-section-top_bar').height();
    $('.sticky').css('top', h);
    if (window.pageYOffset > sticky) {
      menu.classList.add('sticky');
      if (width > 1180) {
        $fixmenu.show();
      } else {
        $mobilemenu.show();
      }
    } else {
      menu.classList.remove('sticky');
      if (width > 1180) {
        $fixmenu.hide();
      } else {
        $mobilemenu.hide();
      }
    }
  }

  $(document).click(function (e) {
    if (e.target.id != 'ins-trigger') {
      $('#instruction').removeClass('show');
    }

    if (!e.target.classList.contains('share')) {
      if ($('.main-share').is(':visible')) {
        $('.main-share').hide();
      }
    }
  });

  $(window).resize(function () {
    fixMenu();
  });

  $('.eb-select-plan-btn').click(function () {
    window.segmentTracking.earlyBirdProjectClicked(projectId);
  });

  // =============================== Radar Chart ===============================
  Chart.defaults.global.defaultFontColor = '#646464';
  Chart.defaults.global.defaultFontFamily =
    "'Helvetica','PingFang TC','微軟正黑體','Microsoft JhengHei',sans-serif";
  Chart.defaults.globaldefaultFontSize = 16;

  function radarObject(labels, data) {
    return {
      type: 'radar',

      data: {
        labels: labels,
        datasets: [
          {
            data: data,
            pointRadius: 0,
            borderColor: '#00c795',
            backgroundColor: 'rgba(196, 242, 229, 0.4)',
          },
        ],
      },
      options: {
        title: {
          display: false,
        },
        legend: {
          display: false,
        },
        layout: {
          padding: {
            left: 0,
            right: 0,
            top: 0,
            bottom: 0,
          },
        },
        scale: {
          ticks: {
            max: 5,
            min: 0,
            stepSize: 1,
            display: false,
          },
          gridLines: {
            color: '#c4f2e5',
            lineWidth: 1.7,
          },
          angleLines: {
            display: false,
          },
          pointLabels: {
            fontSize: 16,
            fontStyle: 600,
          },
        },
      },
    };
  }

  // other functions
  function formatNumber(num) {
    return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
  }

  function round(value, precision) {
    var multiplier = Math.pow(10, precision || 0);
    return Math.round(value * multiplier) / multiplier;
  }

  function timeFormat(time) {
    var t = new Date(time);
    return t.getFullYear() + '/' + (t.getMonth() + 1) + '/' + t.getDate();
  }

  function linkString(max, text) {
    if (text.length > max) {
      return text.substr(0, max);
    } else {
      return text;
    }
  }

  function appendKolLink($dom, $link, text) {
    var width = window.innerWidth > 0 ? window.innerWidth : screen.width;
    var desk_width = $('.kol-text').first().width();
    if (width > 480) {
      var lineTotal = desk_width / 16;
      var desktop = Math.ceil(lineTotal * 3);
      if (text.length > desktop) {
        $dom.html(linkString(desktop, text) + '...');
      }
    } else {
      var mobile = Math.ceil((width / 17.5) * 3);
      if (text.length > mobile) {
        $dom.html(linkString(mobile, text) + '...');
      }
    }
    $dom.append($link);
  }
});
